<template>
  <div class="g-container-p">
    <div class="m-container-p">
      <!-- 面包屑 -->
      <div>
        <h3>
          <slot name="title"></slot>
        </h3>
        <slot name="remark"></slot>
        <el-button type="primary"
                   size="small"
                   @click="imgClick">图片</el-button>
        <el-button type="success"
                   size="small"
                   @click="pdfClick">pdf</el-button>
        <div v-if="isImg">
          <image-upload :src="src"
                        :isPic="true"
                        :picImgs="infoFbPicArr"
                        @getDataArrPic="getDataArrPic"
                        style="width: 80%;">
            <i slot="del"
               class="del-p"></i>
          </image-upload>
        </div>
        <div v-if="isPdf">
          <el-upload class="upload-demo"
                     drag
                     action="https://www.iduilv.com/Api/Common/UploadFile"
                     :data="infoFbFileData"
                     :before-upload="beforeUpload"
                     :file-list="oldInfoFbFileList"
                     :limit="1"
                     accept=".pdf"
                     multiple
                     :on-success="handleSuccess"
                     :on-error="handleError"
                     :on-remove="handleRemove"
                     style="width: 80%;">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          </el-upload>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../../../../../html/pages/originality/createTestReport/createTestReport.scss"

import imageUpload from "../../../../../components/imageUpload/qeImageUpload"

export default {
  name: 'updateInfoFeedback',
  props: ['oldInfoFbPicArr', 'infoFileType', 'oldInfoFbFileList'],
  watch: {
    oldInfoFbPicArr (newValue) {
      this.infoFbPicArr = newValue;
    },
    infoFileType (newValue) {
      if ("IMG" == newValue) {
        // console.log("infoFileType", newValue)
        this.isImg = true
        this.isPdf = false
      } else {
        this.isImg = false
        this.isPdf = true
      }
    }
  },
  data () {
    return {
      src1: require("../../../../../html/pages/originality/createQe/images/upload.jpg"),
      type: "",
      infoFbPicArr: this.oldInfoFbPicArr,//原图
      infoFbFileData: {//文件
        type: 'file',
        file: ''
      },
      isImg: true,
      isPdf: false
    }
  },
  components: {
    imageUpload
  },
  computed: {
    src () {
      return this.src1
    }
  },
  methods: {
    imgClick () {
      this.isImg = true
      this.isPdf = false
      this.$emit('getInfoFeedbackDataArr', this.infoFbPicArr, this.infoFbFileData, "IMG");
    },
    pdfClick () {
      this.isImg = false
      this.isPdf = true
      this.$emit('getInfoFeedbackDataArr', this.infoFbPicArr, this.infoFbFileData, "PDF");
    },
    getDataArrPic (data) {
      this.infoFbPicArr = data
      this.$emit('getInfoFeedbackDataArr', this.infoFbPicArr, this.infoFbFileData, "IMG");
    },
    beforeUpload (file) {
      const isPDF = file.type === 'application/pdf';
      const isLt20M = file.size / 1024 / 1024 < 20;

      if (!isPDF) {
        this.$message.error('上传文件只能是PDF格式!');
      }
      if (!isLt20M) {
        this.$message.error('上传文件大小不能超过 20MB!');
      }

      return isPDF && isLt20M;
    },
    handleSuccess (response, file, fileList) {
      // 成功回调
      console.log(response)
      if (response.Type == 'Success') {
        this.$message.success(response.Content)
        this.infoFbFileData.file = response.Data
      }
      this.$emit('getInfoFeedbackDataArr', this.infoFbPicArr, this.infoFbFileData, "PDF");
      //console.log(response.response.Data, file, fileList)
    },
    // 删除文件
    handleRemove (file, fileList) {
      this.infoFbFileData.file = '';
      this.$emit('getInfoFeedbackDataArr', this.infoFbPicArr, this.infoFbFileData, "PDF");
    },
    handleError (err, file, fileList) {
      // 错误回调
      console.log(err, file, fileList)
    },
    // 上传报告
    async uploadReprot (fn) {

    },
    init () {
      this.type = this.$route.query.type
    },
    created () {
      this.init()
    },
    beforeRouteUpdate (to, from, next) {
      next();
      this.init();
      this.infoFbPicArr = []
    },
    reload () {
      this.uploadReprot(item => {
        window.location.reload()
      })
    },
  },
}
</script>

<style scoped>
</style>
